/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const NotificationsIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    viewBox="0 0 34 32"
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" strokeLinecap="round" strokeLinejoin="round">
      <path d="M27.3333333,22 L27.3333333,14.6666667 C27.3333333,9.79866667 24.2546667,5.65866667 19.9453333,4.05466667 C19.6506667,2.13733333 18,0.666666667 16,0.666666667 C14,0.666666667 12.344,2.13733333 12.0493333,4.05466667 C7.74,5.65866667 4.66666667,9.79866667 4.66666667,14.6666667 L4.66666667,22 C4.66666667,24.2093333 2.87466667,26 0.666666667,26 L31.3333333,26 C29.1213333,26 27.3333333,24.2093333 27.3333333,22 Z" />
      <path d="M20,26 C20,28.2093333 18.208,30 16,30 C13.788,30 12,28.2093333 12,26" />
    </g>
  </svg>
);

export default NotificationsIcon;
